import React, { useState } from 'react';
import './SpeakerCard.css';
import { IoPersonSharp } from 'react-icons/io5';

const SpeakerCard = ({ speaker, style }) => {
  const { name, affiliation, affiliationUrl, bio, photo, link } = speaker;
  const isLong = bio && bio.length > 77;
  const shortBio = isLong ? bio.slice(0, 67) + ' ...' : bio;
  const [expanded, setExpanded] = useState(false);
  const displayedBio = expanded ? bio : shortBio;
  const cardLink = link || affiliationUrl;

  // Build clickable elements only for photo & name
  const PhotoEl = photo ? (
    <img src={photo} alt={name} className="speaker-photo" />
  ) : (
    <div className="speaker-placeholder">
      <IoPersonSharp className="placeholder-icon" aria-label="placeholder" />
    </div>
  );

  const ClickablePhoto = cardLink ? (
    <a href={cardLink} target="_blank" rel="noreferrer">
      {PhotoEl}
    </a>
  ) : (
    PhotoEl
  );

  const NameHeading = <h3 className="speaker-name">{name}</h3>;
  const ClickableName = cardLink ? (
    <a href={cardLink} target="_blank" rel="noreferrer" className="speaker-name-link">
      {NameHeading}
    </a>
  ) : (
    NameHeading
  );

  const Content = () => (
    <>
      {ClickablePhoto}

      {ClickableName}
      {affiliation && <p className="speaker-affiliation">{affiliation}</p>}
      {displayedBio && <p className="speaker-bio">{displayedBio}</p>}
      {isLong && (
        <button
          type="button"
          className="read-more-btn"
          onClick={(e) => {
            e.stopPropagation();
            setExpanded((prev) => !prev);
          }}
        >
          {expanded ? 'Show less' : 'Read more'}
        </button>
      )}
    </>
  );

  
  const hoverableClass = cardLink ? 'hoverable' : '';

  return (
    <div className={`speaker-card fade-in-up ${hoverableClass}`} style={style}>
      <Content />
    </div>
  );
};

export default SpeakerCard;
